import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormArray } from '@angular/forms';

@Component({
    templateUrl: './confirmation-with-notes-modal.html',
    standalone: false
})
export class ConfirmationWithNotesModalComponent {
  text: string;
  subtext: string;
  showNotes: boolean;
  form: UntypedFormGroup;

  constructor(public dialogRef: MatDialogRef<ConfirmationWithNotesModalComponent>, @Inject(MAT_DIALOG_DATA) data: any, private formBuilder: UntypedFormBuilder) {
    this.text = data.text;
    this.subtext = data.subtext;
    this.showNotes = data.showNotes;

    this.form = this.formBuilder.group({
      Notes: [null],
      AdditionalFields: this.formBuilder.array([])
    });

    // Adiciona os campos adicionais para preenchimento
    if (data.additionalFields && data.additionalFields.length > 0) {
      const additionalFieldsControl = <UntypedFormArray>this.form.get('AdditionalFields');

      data.additionalFields.forEach((field: AdditionalField) => {
        additionalFieldsControl.push(this.formBuilder.group({
          Label: [field.Label],
          Name: [field.Name],
          Value: [field.Value]
        }));
      });
    }
  }

  /**
   * Fechar o popup
   * @param  {boolean} confirmed Confirmação da operação (true/false)
   */
  close(confirmed: boolean) {
    const additionalFieldsControl = <UntypedFormArray>this.form.get('AdditionalFields');
    let additionalFields;
    if (additionalFieldsControl.length > 0) {
      additionalFields = additionalFieldsControl.getRawValue();
    } else {
      additionalFields = [];
    }

    this.dialogRef.close({ Confirmed: confirmed, Notes: this.form.get('Notes').value, AdditionalFields: additionalFields });
  }
}

export class AdditionalField {
  constructor(
    public Label: string = null,
    public Name: string = null,
    public Value: string = null
  ) { }
}
